import { render, staticRenderFns } from "./NoteFullItem.vue?vue&type=template&id=65da5444&scoped=true&"
import script from "./NoteFullItem.vue?vue&type=script&lang=js&"
export * from "./NoteFullItem.vue?vue&type=script&lang=js&"
import style0 from "./NoteFullItem.vue?vue&type=style&index=0&id=65da5444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65da5444",
  null
  
)

component.options.__file = "NoteFullItem.vue"
export default component.exports